/*
 * 購入方法（都度 / 定期便）と数量に合わせて、表示価格・打ち消し線・「送料無料」バッジを更新する。
 * 価格は Liquid が data-* に入れた Shopify の money 単位（円×100）。
 *   data-unit-price      … 実際に請求される1袋の価格（都度はキャンペーン割引後、定期便はプラン割引後）
 *   data-compare-price   … 打ち消し線で見せる1袋の通常価格（キャンペーン中の都度購入・テーマ設定でONのときだけ）
 *   data-on-sale         … キャンペーン割引の対象（割引率バッジを出す）
 *   data-effective-price … 送料無料の判定に使う1袋の価格（送料は割引後の小計で判定される）
 * 定期便まとめ割（[data-purchase-options] の data-bulk-*）:
 *   data-bulk-off  … 定期便で data-bulk-min 袋以上のとき、1袋から引く額
 *   data-bulk-from … 開始日時の UNIX 秒（0 なら開始済み）。キャッシュされたページでも開始前は出さない
 */
(() => {
  const yen = cents => Math.round(cents / 100).toLocaleString('ja-JP');

  // 定期便を選んでいて、開始済みのときだけ { min, off } を返す
  const bulkFor = form => {
    const options = form.querySelector('[data-purchase-options]');
    const off = Number(options?.dataset.bulkOff) || 0;
    const min = Number(options?.dataset.bulkMin) || 0;
    const from = Number(options?.dataset.bulkFrom) || 0;
    const started = off > 0 && min > 1 && Date.now() / 1000 >= from;
    const note = options?.querySelector('[data-bulk-note]');
    if (note) note.hidden = !started;
    const plan = form.querySelector('input[name="selling_plan"]:checked');
    return started && plan?.value ? { min, off } : null;
  };

  const sync = form => {
    const plan = form.querySelector('input[name="selling_plan"]:checked');
    const bulk = bulkFor(form);
    const unitAt = (base, qty) => (bulk && qty >= bulk.min ? base - bulk.off : base);
    const quantities = form.querySelector('[data-quantity-options]');
    const source = plan || quantities;
    const unit = Number(source?.dataset.unitPrice || form.dataset.unitPrice) || 0;
    const compare = Number(source?.dataset.comparePrice) || 0;
    const onSale = source?.dataset.onSale === 'true';
    const effective = Number(source?.dataset.effectivePrice) || unit;
    form.dataset.currentUnitPrice = String(unit);
    form.dataset.bulkMin = bulk ? String(bulk.min) : '';
    form.dataset.bulkOff = bulk ? String(bulk.off) : '';
    const scope = form.closest('section') || form;

    let selected = 1;
    if (quantities) {
      const threshold = Number(quantities.dataset.threshold) || 0;
      const freeAll = quantities.dataset.freeAll === 'true';
      quantities.querySelectorAll('input[name="quantity"]').forEach(input => {
        const label = input.closest('label');
        const qty = Number(input.value) || 1;
        const price = label?.querySelector('[data-line-price]');
        if (price) price.textContent = yen(unitAt(unit, qty) * qty);
        const was = label?.querySelector('[data-line-was]');
        if (was) was.textContent = yen(compare * qty);
        const wasWrap = label?.querySelector('[data-line-was-wrap]');
        if (wasWrap) wasWrap.hidden = !compare;
        const badge = label?.querySelector('[data-free-badge]');
        if (badge) badge.hidden = !(freeAll || (threshold > 0 && unitAt(effective, qty) * qty >= threshold));
      });
      selected = Number(quantities.querySelector('input[name="quantity"]:checked')?.value) || 1;
    }
    const selectedUnit = unitAt(unit, selected);
    const total = scope.querySelector('[data-buy-price]');
    if (total) total.textContent = yen(selectedUnit * selected);
    const was = scope.querySelector('[data-buy-was]');
    if (was) was.textContent = yen(compare * selected);
    const saleRow = scope.querySelector('[data-sale-row]');
    if (saleRow) saleRow.hidden = !onSale;
    // 「◯月◯日まで・カートで自動適用」は都度購入にだけ効くので、定期便を選んでいる間は隠す
    scope.querySelectorAll('[data-campaign-note]').forEach(note => { note.hidden = !onSale; });
    const perCup = scope.querySelector('[data-per-cup]');
    if (perCup) perCup.textContent = yen(selectedUnit / (Number(perCup.dataset.servings) || 10));
    form.dispatchEvent(new CustomEvent('fermenta:price-change', { bubbles: true, detail: { unit: selectedUnit, compare } }));
  };

  document.querySelectorAll('form[data-product-form]').forEach(form => {
    form.addEventListener('change', () => sync(form));
    sync(form);
  });
})();
